// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2iBrN","obliqueLineWrap":"membershipbadge_obliqueLineWrap__5ol62","obliqueLine":"membershipbadge_obliqueLine__20smg"};